<template>
    <div id="buyingManagement" class="page-content">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>买货登记</el-breadcrumb-item>
            <el-breadcrumb-item>转寄管理</el-breadcrumb-item>
        </el-breadcrumb>

        <section class="seaerch-wrapper">
            <el-form class="search-form" :model="queryParams" ref="queryForm">
                <el-form-item label="转寄日期" prop="dateRange" label-width="100px">
                    <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" style="width: 100%;"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                        size="small" @change="dataChange"></el-date-picker>
                </el-form-item>

                <el-form-item label="订单编号" prop="ordernumber" label-width="100px">
                    <el-input v-model="queryParams.ordernumber" clearable placeholder="订单编号" size="small" />
                </el-form-item>

                <el-form-item label="转寄快递单号" prop="returnTrackingNumber" label-width="100px">
                    <el-input v-model="queryParams.forwardTrackingNumber" clearable placeholder="转寄快递单号" size="small" />
                </el-form-item>

                <el-form-item label-width="100px">
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                </el-form-item>
            </el-form>
        </section>
        <div style="background-color: white;padding: 20px;">
            <el-row :gutter="10" class="mb8" style="padding-bottom: 20px;">
                <!-- <el-col :span="1.5">
                    <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">转寄/退款</el-button>
                </el-col> -->
                <el-col :span="1.5">
                    <el-button size="mini" @click="importTemplate">下载数据</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="changeHistory">变更历史</el-button>
                </el-col>
            </el-row>

            <el-table v-loading="loading" :data="tableData" @row-click="taskidFun">
                <el-table-column label="转寄收件人" align="left" key="forward_recipient" prop="forward_recipient" />
                <el-table-column label="转寄收件人手机号" align="left" key="forward_recipient_phone"
                    prop="forward_recipient_phone" />
                <el-table-column label="转寄收件人地址" align="left" key="forward_address" prop="forward_address" />
                <el-table-column label="转寄运费支付日期" align="left">
                    <template slot-scope="scope" v-if="scope.row.forward_payment_date">
                        {{ scope.row.forward_payment_date | fullTimeShort }}
                    </template>
                </el-table-column>
                <el-table-column label="转寄快递单号" align="left" key="forward_tracking_number"
                    prop="forward_tracking_number" />
                <el-table-column label="转寄运费支付截图" align="left">
                    <template slot-scope="scope">
                        <el-popover placement="top-start" title="更多图片" width="200" trigger="hover">
                            <div style="display: flex;">
                                <img v-for="(url, index) in parseScreenshots(scope.row.forward_payment_screenshot)" :key="index"
                                    :src="url" alt
                                    style="width: 50px; height: 50px; cursor: pointer;float: left;margin-left: 10px;"
                                    @click.stop="bigImg(url)" />
                            </div>
                            <img slot="reference" :src="parseScreenshots(scope.row.forward_payment_screenshot)[0]" alt
                                style="width: 50px; height: 50px; cursor: pointer;"
                                @click.stop="bigImg(parseScreenshots(scope.row.forward_payment_screenshot)[0])" />
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="转寄运费金额" align="left" key="forward_payment_price" prop="forward_payment_price" />
                <el-table-column label="创建时间" align="left">
                    <template slot-scope="scope" scope.row.createtime>
                        {{ scope.row.createtime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="创建人" align="left" key="createuser" prop="createuser" />
                <el-table-column label="更新时间" align="left">
                    <template slot-scope="scope" v-if="scope.row.updatetime">
                        {{ scope.row.updatetime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="更新人" align="left" key="updateuser" prop="updateuser" />
            </el-table>
            <div v-show="this.tableData.length > 0">
                <pagination :currentPage="currentPage" :pageSizes="[10,20,50,100]" :total="totalNum"
                    @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
                </pagination>
            </div>
        </div>
        <el-dialog title="图片详情" :visible.sync="bigOpen">
            <div style="text-align: center;">
                <img :src="bigurl" style="width: 400px;height: auto;">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="bigOpen = false" size="small">取 消</el-button>
            </div>
        </el-dialog>
        <childForward ref="childForward" @call-parent-method="parentMethod" type="2" />
    </div>
</template>

<script>
import pagination from "../../../components/dataTable/pagination";
import childForward from "../buyingManagement/childForward";
export default {
    name: "returnManagement",
    components: {
        pagination, childForward
    },
    data() {
        return {
            queryParams: {
                pageNo: 1,
                pageSize: 10,
                ordernumber: null,
                forwardTrackingNumber: null,
                begintime: null,
                endtime: null,
            },
            title: '',
            totalNum: 0,
            currentPage: 0,
            dateRange: [],
            loading: false,
            tableData: [],
            // 表单参数
            form: {},
            taskData: [],
            returnData: [],
            returnList: [],
            bigurl: '',
            bigOpen: false,
        };
    },
    created() {
        this.getList();
    },
    methods: {
        parseScreenshots(screenshotString) {
            return screenshotString.split(',');
        },
        bigImg(img) {
            this.bigurl = img;
            this.bigOpen = true;
        },
        dataChange() {
            if (!this.dateRange) {
                this.dateRange = []
            }
            this.queryParams.begintime = this.dateRange[0] ? this.dateRange[0] : null
            this.queryParams.endtime = this.dateRange[1] ? this.dateRange[1] : null
        },
        parentMethod() {
            this.getList();
        },
        // 变更历史
        changeHistory() {
            this.$router.push({
                path: '/salesRegistration/buyingHistory',
                query: { modulename: 'ZJ', name: '转寄管理', url: '/salesRegistration/buyingManagement/index' }
            })
        },
        // 展示详情
        taskidFun(data) {
            let params = {
                id: data.id
            }
            fetch({
                url: "hcm/hcmOrderForward/getOrderforwarddetails",
                method: "get",
                params: params,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    let dataToSend = {
                        title: "转寄详情",
                        form: result.data
                    }
                    this.$refs.childForward.updateChange(dataToSend);
                }
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNo = 1;
            this.dataChange();
            this.getList();
        },
        // 数据源
        getList() {
            this.loading = true;
            fetch({
                url: "hcm/hcmOrderForward/getList",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.tableData = result.data.content;
                    this.totalNum = result.data.totalElements;
                    this.loading = false;
                }
            })
        },
        // 下载数据
        importTemplate() {
            fetch({
                url: "hcm/hcmOrderReturn/hcmOrderForwardDownload",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "blob"
            }).then((res) => {
                //下载
                let url = window.URL.createObjectURL(new Blob([res]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', '转寄管理.xlsx')
                document.body.appendChild(link)
                link.click()
            })
        },
        // 新增
        handleAdd() {
            let dataToSend = {
                title: "转寄录入",
            }
            this.$refs.childForward.updateChange(dataToSend);
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = `${val}`
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNo = `${val}`
            this.getList();
        },
    }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 50px;
    width: 50px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

#buyingManagement {
    .el-table th {
        background-color: #f3f7ff !important;
    }

    .el-table__empty-text {
        padding-top: 100px;
        background: url("../../../assets/img/other/nodata.svg") no-repeat;
        background-position: center 66px;
    }

    .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #d9d9d9;
    }

    .el-table thead {
        color: #333333;
        font-weight: 500;
    }

    .el-button+.el-button {
        margin-left: 0px;
    }

    .bottom_page .el-pagination {
        text-align: right;
        margin-top: 0px;
        padding-bottom: 0px;
    }
}
</style>